<template>
    <div>
        <div v-if="!componentIsLoading" class="content-wrapper">
            <h4>Nouveau bénéficiaire</h4>

            <hr>

            <resource-form
                v-if="form"
                ref="creationForm"
                :model="form.model"
                :schema="form.schema"
                :triggers="form.triggers"
                :no-form-group="true"
                @submit="addOwnerToDeclaration">
                <template slot="cancel">
                    <button class="btn btn-default btn-sm" @click.prevent="$emit('form-closed')">Annuler</button>
                </template>
            </resource-form>
        </div>

        <component-loader v-else></component-loader>
    </div>
</template>

<script type="text/babel">
    import {mapState, mapActions} from "vuex"
    import ResourceForm from 'components/Forms/ResourceForm'
    import ComponentLoader from 'components/ComponentLoader'
    
    export default {
        name: 'BeneficialOwnerCreationForm',

        props: {
            declarationId: {
                type: Number,
                default: null,
                required: true
            }
        },

        components: {
            ResourceForm,
            ComponentLoader
        },

        data() {
            return {
                componentIsLoading: false
            }
        },

        created() {
            this.fetchCreationForm()
        },

        methods: {
            ...mapActions('beneficialOwners', [
                'fetchBeneficialOwnerCreationForm',
                'storeBeneficialOwner'
            ]),

            fetchCreationForm() {
                this.componentIsLoading = true

                this.fetchBeneficialOwnerCreationForm(this.declarationId)
                    .then(() => this.componentIsLoading = false)
            },

            addOwnerToDeclaration(event) {
                let owner = event.data
                owner.beneficial_owners_declaration_id = this.declarationId

                this.creationForm.isLoading = true
                this.storeBeneficialOwner(owner)
                    .then(() => this.$emit('success'))
                    .catch(() => {})
                    .then(() => this.creationForm.isLoading = false)
            }
        },

        computed: {
            ...mapState('beneficialOwners', {
                'form': 'ownerCreationForm'
            }),

            creationForm() {
                return this.$refs.creationForm
            }
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrapper {
        padding: 15px;
        background-color: #fafafa;
    }
</style>



// WEBPACK FOOTER //
// client/components/BeneficialOwners/BeneficialOwnerCreationForm.vue